module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel04_770_280_ko-c55a91131e987416932f916780286761.jpg";